import { render } from "./submit-button.vue?vue&type=template&id=675eb4d4"
import script from "./submit-button.vue?vue&type=script&lang=js"
export * from "./submit-button.vue?vue&type=script&lang=js"

import "./submit-button.vue?vue&type=style&index=0&id=675eb4d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__